import React from "react";
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

const ContentComponent = ({ isOpen, toggle, recipe }) => {
  // console.log('recipe: ', recipe);
  const nameOrder =
    recipe && recipe.length > 0 ? recipe[0].product.name : "Công thức";

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      className="shadow-none mt-5"
    >
      <ModalHeader toggle={toggle}>
        <span className="font-weight-bold" style={{ fontSize: "1.4rem" }}>
          {nameOrder}
        </span>
      </ModalHeader>
      <ModalBody className="p-0">
        <div className="table-responsive">
          <table className="table table-striped mb-0">
            <thead className="bg-light">
              <tr>
                <th className="border-top-0 pl-4" style={{ width: "60%" }}>
                  NGUYÊN LIỆU
                </th>
                <th className="border-top-0 text-right pr-4">ĐỊNH LƯỢNG</th>
              </tr>
            </thead>
            <tbody>
              {recipe?.map((r, idx) => {
                return (
                  <tr key={idx}>
                    <td className="pl-4 align-middle">
                      <span style={{ fontSize: "1.2rem", fontWeight: "500" }}>
                        {r.stock.name}
                      </span>
                    </td>
                    <td className="text-right pr-4 align-middle">
                      <span
                        className="text-primary font-weight-bold"
                        style={{ fontSize: "1.5rem" }}
                      >
                        {r.count}
                      </span>
                      <span
                        className="text-muted ml-1"
                        style={{ fontSize: "1rem" }}
                      >
                        {r.stock.unit}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {(!recipe || recipe.length === 0) && (
          <div className="text-center p-4 text-muted">
            Chưa có công thức cho món này
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ContentComponent;
